import { apiClient } from '@src/services/http-common'
import { useMutation } from '@tanstack/react-query'
import { SubmitPaymentsDTO } from '../@types/SubmitPaymentsDTO'

const submitPayment = async (paymentData: SubmitPaymentsDTO) => {
  const { loanId, ...data } = paymentData
  const url = `/Loans/${loanId}/Payments`
  const response = await apiClient.post<SubmitPaymentsDTO>(url, data)
  return response.data
}

export const usePostPayment = () => {
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: submitPayment,
  })

  return [mutateAsync, isPending, reset] as const
}
